__turbopack_context__.v({
  "datepicker": "datepicker-module-scss-module__hNzFSW__datepicker",
  "ltr": "datepicker-module-scss-module__hNzFSW__ltr",
  "popover": "datepicker-module-scss-module__hNzFSW__popover",
  "rtl": "datepicker-module-scss-module__hNzFSW__rtl",
});
